import { Link,useNavigate } from "react-router-dom";
import { useState } from 'react';

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {

    const [form, setForm] = useState({ name: '', email: '', message: '' });
    const navigate = useNavigate()  
    const handleChange = e => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };
  
    const handleSubmit = async e => {
      e.preventDefault();
      const scriptURL = "https://script.google.com/macros/s/AKfycbwB_IavSbz7aS9pWOAsvui615CdHsyeZcHaywu3tFcbp_-teLPIyv3qk875SIt_pyZkIg/exec"; // Replace with actual script URL
      try {
        toast.success("Thank you for your message.Our Team will contact you soon!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          })
        fetch(scriptURL,{
          method:"POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body:(`Name=${e.target.name.value}&Email=${e.target.email.value}&Message=${e.target.message.value}`)
        }).then(res=>res.text()).then(data=>{
        
        }).then(res=>{
          navigate('/')
        })
        .catch(error=>console.log(error))

      } catch (err) {
        console.error("Error submitting to sheet", err);
      }
    };
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f9fafb" }}>
      <header style={{ backgroundColor: "rgb(201 215 255)", padding: "1rem", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h1 style={{ fontSize: "1.5rem", fontWeight: "600", color: "#1d4ed8" }}>Contact Us</h1>
        <Link to="/" style={{ color: "#2563eb", textDecoration: "none", fontSize: "1.125rem" }}>
          Home
        </Link>
      </header>

      <main style={{ padding: "1.5rem", display: "flex", justifyContent: "center" }}>
        <form onSubmit={handleSubmit} style={{ backgroundColor: "white", padding: "1.5rem", borderRadius: "0.5rem", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "100%", maxWidth: "500px" }}>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "500" }}>Name:</label>
          <input type="text" name="name" value={form.name} onChange={handleChange}
          style={{ width: "100%", padding: "0.5rem", border: "1px solid #ccc", borderRadius: "0.25rem", marginBottom: "1rem" }} />

          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "500" }}>Email:</label>
          <input type="email" name="email" value={form.email} onChange={handleChange}
          style={{ width: "100%", padding: "0.5rem", border: "1px solid #ccc", borderRadius: "0.25rem", marginBottom: "1rem" }} />

          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "500" }}>Message:</label>
          <textarea name="message" value={form.message} onChange={handleChange} 
          style={{ width: "100%", padding: "0.5rem", border: "1px solid #ccc", borderRadius: "0.25rem", marginBottom: "1rem" }} rows="4"></textarea>

          <button type="submit" style={{ backgroundColor: "#2563eb", color: "white", padding: "0.5rem", borderRadius: "0.25rem", width: "100%", border: "none", cursor: "pointer" }}>
            Submit
          </button>
        </form>
      </main>
      <ToastContainer />
    </div>
  );
};
export default ContactUs;
